module.exports = __webpack_public_path__ + "static/media/header-banner-grey.3e7d51df.jpg";